var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFileCopy2Line = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66653 3.99998V1.99998C4.66653 1.63179 4.96501 1.33331 5.3332 1.33331H13.3332C13.7014 1.33331 13.9999 1.63179 13.9999 1.99998V11.3333C13.9999 11.7015 13.7014 12 13.3332 12H11.3332V13.9994C11.3332 14.3679 11.0333 14.6666 10.662 14.6666H2.67111C2.30039 14.6666 2 14.3702 2 13.9994L2.00173 4.66723C2.0018 4.29872 2.30176 3.99998 2.67295 3.99998H4.66653ZM3.33495 5.33331L3.33346 13.3333H9.99987V5.33331H3.33495ZM5.99987 3.99998H11.3332V10.6666H12.6665V2.66665H5.99987V3.99998ZM4.66667 7.33331H8.66667V8.66665H4.66667V7.33331ZM4.66667 9.99998H8.66667V11.3333H4.66667V9.99998Z",
    fill: "#FC6328"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFileCopy2Line, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/file-copy-2-line.0c596bca.svg";
export { ForwardRef as ReactComponent };